// extracted by mini-css-extract-plugin
export default {"divContainer":"styles_divContainer__96qWw","img":"styles_img__8htnf","overlay":"styles_overlay__7YNiF","imgPlay":"styles_imgPlay__DtYil","time":"styles_time__8Hl1S"};